module.exports = __webpack_public_path__ + "img/down-arrow.62cae6d2.webp";